import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Footer from '../Footer';
import Navbar1 from '../Navbar1';
import Categories1 from '../Categories1';
import Section2 from '../Section2';
import Breadcrumb from '../Breadcrumb';

import Swal from 'sweetalert2'

import './MyStyles1.css';
import ProductDetail from '../ProductDetail';
//import SubcategoriesProducts from './SubcategoriesProducts';



function ProductDetailPage({idproduct}) {
    //State
    const initialCart = () => {
        const localStorageCart = localStorage.getItem('cart')

        return localStorageCart ? JSON.parse(localStorageCart) : []
    }

    const [infoProduct, setInfoProduct] = useState('');

    const [cart, setCart] = useState(initialCart);

    useEffect(() => {
        getProductDetail(idproduct);
    }, []);

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart))
    }, [cart]);

    const getProductDetail = (idproduct) => {
        //let _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');//obtenemos el token del form
        let url = '/api/data_info_product';

        const formData = new FormData();
        formData.append('id_product', idproduct);


        fetch(url, {
            method: "POST",
            headers: {
                //'X-CSRF-TOKEN': _token //asignamos el token frm a los headers
            },
            body: formData,

        }).then ( response => response.json())
        .then ( data => {
            if (data.response == 'success') {
                
                //console.log(data.data);
                setInfoProduct(data.data);
            }
            if (data.response == 'info') {
                //console.log(data.message);
                Swal.fire('Upss', data.message, 'info');
                return;
            }


        }).catch(error =>{
            console.error(error);
        });
    }

    const addToCart = (item) => {
    
            const itemExists = cart.findIndex(itm => itm.productDessId === item.dessProductId);
    
            if (itemExists >= 0) {
                //si existe, solo modifica la propiedad cantidad
                
                /*let new_item = cart[itemExists];//obtenemos el item
    
                new_item.quantity++;//modificamos e incrementamos la cantidad
    
                let n_filtro = cart.filter(itm => itm.productDessId != item.productDessId);//quitamos el producto que se quiere reemplazar
    
                n_filtro.push(new_item);//agregamos el nuevo producto modificado
    
                setCart(n_filtro);//reemplazamos el array*/
    
                const copy_cart = [...cart];
    
                copy_cart[itemExists].quantity++;
    
                copy_cart[itemExists].subtotal = copy_cart[itemExists].price1 * copy_cart[itemExists].quantity;
    
                setCart(copy_cart);
    
                Swal.fire({
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true, 
                    title: 'Producto agregado al carrito',
                    customClass: {
                        container: 'mi-sweetalert-container',
                    },
                });
                
            } else {
                //agregamos el item al carrito
                let productCart = {
                    productDessId: item.dessProductId,
                    url_img_product: item.url_img_product,
                    description: item.description,
                    quantity: item.quantity,
                    price1: item.price1,
                    name_product: item.name_product,
                    dess_unidade: item.dess_unidade,
                    subtotal: item.subtotal,
                    product_type: item.dess_tipo_producto,
                    tipoProductoId: item.dess_tipo_producto.tipoProductoId
                }
        
                setCart([...cart, productCart]);
    
                Swal.fire({
                    icon: 'success',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true, 
                    title: 'Producto agregado al carrito',
                    customClass: {
                        container: 'mi-sweetalert-container',
                    },
                });
            }
            
    }

    const quitItemCart = (itemId) => {

        /*let orignal_cart = [...cart];

        let n_filtro = orignal_cart.filter(itm => itm.productDessId != itemId);//quitamos el producto que se quiere reemplazar

        setCart(n_filtro);//reemplazamos el array*/

        //una vesión más corta
        setCart(prevCart => prevCart.filter(item => item.productDessId != itemId))
    }

    const setQuantityInput = (index, value) => {
        
        let cant;
        const o_cart = [...cart];
        let indxp = index;

        let peso_prod = 1;//puede cambiar dependiendo del gramage del producto

        
        if (o_cart[indxp].tipoProductoId == 1) {
            cant = value < 0 ? 1 : parseInt(value, 10);

            o_cart[indxp].quantity = cant;
            o_cart[indxp].subtotal = o_cart[indxp].price1 * cant;
            setCart(o_cart);
        }
        if (o_cart[indxp].tipoProductoId == 2) {
            cant = value < 0.01 ? 0 : parseFloat(value).toFixed(2);

            o_cart[indxp].quantity = cant;
            o_cart[indxp].subtotal = (peso_prod * o_cart[indxp].price1) * cant;
            setCart(o_cart);
        }


        //o_cart[indxp].quantity = cant;

        //o_cart[indxp].subtotal = o_cart[indxp].price1 * cant;

        

    }

    const setIncrementDecrement = (index, value) => {
        const o_cart = [...cart];
        let word = value;
        let indxp = index;

        if (word == 'increment') {
            o_cart[indxp].quantity = o_cart[indxp].quantity++;
            o_cart[indxp].subtotal = o_cart[indxp].price1 * o_cart[indxp].quantity;

            setCart(o_cart);
        } else {
            if (o_cart[indxp].quantity == 1) {
                //por default quedará en cero
                let itm = o_cart[indxp];
                quitItemCart(itm.productDessId)
            } else {

                o_cart[indxp].quantity = o_cart[indxp].quantity--;
                o_cart[indxp].subtotal = o_cart[indxp].subtotal - o_cart[indxp].price1;
    
                setCart(o_cart);
            }
        }
    }

    const limpiarCarrito = () => {

        setCart([]);
    }

    const sendQuotationWhastapp = () => {
        const toSend = [...cart];

        let phoneNumber = '9833513355';
        let message = 'Hola, buen día, me gustaría solicitar cotización de los siguientes productos: \n \n';

        toSend.forEach(itm => {
            message += `- ${itm.name_product+', '+itm.quantity+' '+itm.dess_unidade.unidad}\n`;
        });

        //codificar el mensaje para no tener problemas con las url, siempre que se necesite enviar texto por las url, utiliza este metodo
        let encodedMessage = encodeURIComponent(message);

        let url = 'https://api.whatsapp.com/send?phone=52'+phoneNumber+'&text='+encodedMessage;
        
        //console.log(message);
        window.open(url, '_blank')


    }

    return (
        <>
            <Navbar1
                cart={cart}
                quitItemCart={quitItemCart}
                setQuantityInput={setQuantityInput}
                setIncrementDecrement={setIncrementDecrement}
                limpiarCarrito={limpiarCarrito}
                sendQuotationWhastapp={sendQuotationWhastapp}
            />   
            <div style={{paddingTop: '80px'}}>
                <div className="fullwidth-template">
                    {
                        /*
                        <Breadcrumb 
                            url={'/subcategories/'+idcategory}
                            text_before={categoryName}
                            text_active={subcategoryName}
                            level={true}
                        />
                        */
                    }
                    
                    <ProductDetail
                        infoproduct={infoProduct}
                        addToCart={addToCart}
                    />

                </div>
                <Footer />
            </div>
        </>
    );
}

export default ProductDetailPage;

if (document.getElementById('productdetail')) {
    //ReactDOM.render(<Listproducts />, document.getElementById('productdetail'));

    const element = document.getElementById('productdetail');
    const idproduct = element.getAttribute('data-idproduct');
    ReactDOM.render(<ProductDetailPage idproduct={idproduct} />, element);
}